import { Controller } from "@hotwired/stimulus"

// Periode-formulier (TraineeRotation): bij een vakgebied-programma bepaalt het
// programma het specialisme (verberg het losse specialism-veld) en filtert de
// supervisor-dropdown op eligible (skill/fellow). Stimulus triggert alleen; het
// herladen + swappen gebeurt via de turbo-frame "rotation_supervisor_options".
export default class extends Controller {
  static values = { url: String }
  static targets = ["specialismField", "specialism", "program"]

  refresh() {
    const programId = this.hasProgramTarget ? this.programTarget.value : ""
    const specialism = this.hasSpecialismTarget ? this.specialismTarget.value : ""

    if (this.hasSpecialismFieldTarget) {
      this.specialismFieldTarget.classList.toggle("hidden", Boolean(programId))
    }

    const frame = document.getElementById("rotation_supervisor_options")
    if (!frame || !this.urlValue) return

    // Behoud de huidige supervisor-keuze als die na het filteren nog geldig is.
    const current = frame.querySelector("select")?.value

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.delete("program_id")
    url.searchParams.delete("specialism")
    url.searchParams.delete("supervisor_id")
    if (programId) url.searchParams.set("program_id", programId)
    else if (specialism) url.searchParams.set("specialism", specialism)
    if (current) url.searchParams.set("supervisor_id", current)

    const next = url.toString()
    if (frame.src === next) return
    frame.src = next
  }
}
